import { fetchSummary, fetchStats } from "../actions/dashboard_summary_action";
import { fetchStatsMeta } from "../actions/dashboard_summary_meta_action";
import Helping from "../helpers/Helping";
import Service from "../helpers/service";
import { API_URL } from '../config/urls';
import { REPORTS } from '../config/routes';
import { trackPromise } from 'react-promise-tracker';

let updateCallback = (res) => {

}

export const getSummary = () => {
    return dispatch => {
        return trackPromise(
            Service.postCall(API_URL.ADMIN_TRADING_API + REPORTS, { action: "summary" }).then(response => {
                return dispatch(fetchSummary(response.data.payload));
            })
                .catch(error => {
                    Helping.redirectToLogin(error);
                    dispatch(fetchSummary(''))

                    return updateCallback({
                        ...Helping.setNetworkRequestError(error, "fetching summary")
                    })
                })
        )
    };
};

export const getStats = (type) => {
    return dispatch => {
        return trackPromise(
            Service.getCall(API_URL.ADMIN_API + "user-stats?type=" + type).then(response => {
                const data = {
                    options: {
                        chart: {
                            type: 'bar',
                            toolbar: {
                                show: false
                            }
                        },
                        plotOptions: {
                            bar: {
                                horizontal: false,
                                columnWidth: '20%',
                                endingShape: 'rounded'
                            },
                        },
                        dataLabels: {
                            enabled: false
                        },
                        stroke: {
                            show: true,
                            width: 2,
                            colors: ['transparent']
                        },
                        xaxis: {
                            categories: response.data.payload.columns,
                            labels: {
                                style: {
                                    colors: "#ababab"
                                }
                            },
                        },
                        legend: {
                            horizontalAlign: 'left'
                        },
                        yaxis: {
                            title: {
                                text: 'Values',
                                style: {
                                    color: "#ababab"
                                }
                            },
                            labels: {
                                style: {
                                    colors: "#ababab"
                                }
                            },
                        },
                        fill: {
                            opacity: 1
                        },
                    },
                    series: [{
                        name: 'Users',
                        data: response.data.payload.users
                    }]
                }
                dispatch(fetchStats(data));
                return dispatch(fetchStatsMeta({
                    user_type: type
                }))
            })
                .catch(error => {
                    Helping.redirectToLogin(error);
                    dispatch(fetchStats(''));
                    dispatch(fetchStatsMeta({
                        user_type: type
                    }))

                    return updateCallback({
                        ...Helping.setNetworkRequestError(error, "fetching user stats")
                    })
                })
        )
    };
};